import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useCallback, useContext, useMemo, useState } from 'react';
import styled from 'styled-components';
import useId from '../useId';
var Wrapper = styled.div.withConfig({
  displayName: "RadioButtonGroup__Wrapper",
  componentId: "sc-1pg8dgy-0"
})(["\n  text-align: left;\n"]);
var Context = /*#__PURE__*/React.createContext(undefined);
export function useRadioButtonGroupState() {
  return useContext(Context);
}
export default function RadioButtonGroup(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      name = _ref.name,
      controlledValue = _ref.value,
      rest = _objectWithoutProperties(_ref, ["children", "onChange", "name", "value"]);

  var autoName = useId('radio-auto-');
  name = name || autoName;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      uncontrolledValue = _useState2[0],
      setUncontrolledValue = _useState2[1];

  var value = typeof controlledValue === 'undefined' ? uncontrolledValue : controlledValue;
  var handleChange = useCallback(function (event) {
    setUncontrolledValue(event.target.value);

    if (onChange) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      onChange(event, ...args);
    }
  }, [onChange]);
  var context = useMemo(() => ({
    name,
    onChange: handleChange,
    value
  }), [name, handleChange, value]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    role: "radiogroup"
  }, rest), /*#__PURE__*/React.createElement(Context.Provider, {
    value: context
  }, children));
}
RadioButtonGroup.Context = Context;
RadioButtonGroup.useState = useRadioButtonGroupState;